const BlueBadge = ({ children, theme = "default", textBlack }) => {
  const bgColor = {
    default: '#41B8E4',
    yellow: '#FBBD34',
    'light-green': '#adff9f'
  };

  return (
    <div
      style={{ backgroundColor: bgColor[theme] || bgColor.default, color: textBlack ? '#000' : '#fff' }}
      className="px-2 py-1 rounded"
    >
      {children}
    </div>
  );
};

export default BlueBadge;